import { useSelector } from 'react-redux';

import { RootState } from '@/shared/redux/reducers';

/**
 * Reads the current user's roles from the store and tests them against
 * `allowedRoles`. Named as a hook because it calls useSelector - it may only be
 * used from a component or another hook.
 */
const useUserCan = (allowedRoles: string[]) => {
  const userRole = useSelector((state: RootState) => state.auth.role) ?? [];

  return userRole.some((role) => allowedRoles.includes(role));
};

export default useUserCan;
